export function bestOffer(cart, product) {
  const variants = product.variants.map(v => ({...v, boxes: Number((v.title.match(/^(\d+) boîte/) || [])[1])}));
  const map = new Map(variants.map(v => [v.id, v]));
  const lines = cart.items.filter(i => i.product_id === product.id);
  if (!lines.length || cart.total_discount > 0 || lines.some(i => !map.get(i.variant_id)?.boxes || i.selling_plan_allocation || Object.keys(i.properties || {}).length)) return null;
  const count = lines.reduce((n,i) => n + map.get(i.variant_id).boxes * i.quantity, 0);
  if (count > 60) return null;
  const dp = Array(count + 1).fill(null); dp[0] = {price:0, quantities:{}};
  for (let n=1;n<=count;n++) for (const v of variants) {
    if (!v.available || !v.boxes || v.boxes > n || !dp[n-v.boxes]) continue;
    const prev=dp[n-v.boxes], price=prev.price+v.price;
    if (!dp[n] || price < dp[n].price) dp[n]={price,quantities:{...prev.quantities,[v.id]:(prev.quantities[v.id]||0)+1}};
  }
  const current = lines.reduce((n,i)=>n+i.final_line_price,0), best=dp[count];
  if (!best || best.price >= current) return null;
  const updates={}, existing=new Set();
  for (const line of lines) { if (existing.has(line.variant_id)) return null; existing.add(line.variant_id); updates[line.key]=best.quantities[line.variant_id]||0; }
  for (const [id,quantity] of Object.entries(best.quantities)) if (!existing.has(Number(id))) updates[id]=quantity;
  return {updates, savings:current-best.price, count, price:best.price};
}
if (typeof window !== 'undefined' && !customElements.get('neoman-cart-offer')) {
  const { StandardEvents } = await import('@shopify/events');
  class CartOffer extends HTMLElement {
    version = 0;
    refresh = (event) => {
      this.replaceChildren();
      Promise.resolve(event.promise).then(() => this.load()).catch(() => this.load());
    };
    connectedCallback() {
      document.addEventListener(StandardEvents.cartLinesUpdate, this.refresh);
      document.addEventListener(StandardEvents.cartDiscountUpdate, this.refresh);
      this.load();
    }
    disconnectedCallback() {
      this.version++;
      document.removeEventListener(StandardEvents.cartLinesUpdate, this.refresh);
      document.removeEventListener(StandardEvents.cartDiscountUpdate, this.refresh);
    }
    async read() {
      const root=window.Shopify?.routes?.root||'/';
      const [c,p]=await Promise.all([fetch(root+'cart.js'),fetch(root+'products/brosse-a-dents-crin-de-cheval-pack-de-4.js')]);
      if (!c.ok || !p.ok) throw Error('Lecture impossible');
      return {cart:await c.json(),product:await p.json()};
    }
    async load() {
      const version = ++this.version;
      try {
        const data=await this.read(); if (!this.isConnected || version !== this.version) return;
        const offer=bestOffer(data.cart,data.product); this.replaceChildren();
        if (!offer) return;
        const money=n=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:data.cart.currency}).format(n/100);
        const heading=document.createElement('strong'); heading.textContent='Le même nombre de brosses, un meilleur prix.';
        const text=document.createElement('p'); text.textContent=`Regroupez vos ${offer.count} boîtes : ${money(offer.price)} au lieu de ${money(offer.price+offer.savings)}. Vous économisez ${money(offer.savings)}.`;
        const button=document.createElement('button'); button.type='button';button.textContent='Profiter du meilleur tarif';
        const status=document.createElement('p');status.setAttribute('role','status');
        this.append(heading,text,button,status);
        button.addEventListener('click',async()=>{
          button.disabled=true;status.textContent='Mise à jour du panier…';
          try {
            const fresh=await this.read(), next=bestOffer(fresh.cart,fresh.product);
            if (!next || JSON.stringify(next)!==JSON.stringify(offer)) { await this.load(); return; }
            const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:next.updates})});
            const result=await response.json();
            if (!response.ok || result.status) throw Error(result.description||'Mise à jour impossible.');
            window.location.assign((window.Shopify?.routes?.root||'/')+'cart');
          } catch (error) {status.textContent='Impossible de regrouper les boîtes. Vérifiez votre panier et réessayez.';button.disabled=false;}
        });
      } catch { /* The normal cart remains usable when the suggestion is unavailable. */ }
    }
  }
  customElements.define('neoman-cart-offer',CartOffer);
}
